"use strict";
const XIcon = (props: { size: string; }) => (
  <span style={{
    display: 'inline-block',
    background: `url(/images/news/x.svg) no-repeat center center`,
    backgroundSize: 'contain',
    width: props.size,
    height: props.size,
  }}/>
);

export default XIcon;
